t = require('views/internal/teacup-with-helpers')('archived_lists')

module.exports = ->
  t.ul '.archive-list.js-archive-items'

  t.p '.js-empty-message.empty-list'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/archived_lists.coffee